import React from 'react';
import { TipsMapType } from '../index';
// export const newsTopicTips: TipsMapType = {
//   en: `The following topics are clustered from news headlines and are not related to the main content of the news articles.`,
//   zh: '话题仅通过新闻标题归类',
// };

export const newsKeywordTips: TipsMapType = {
  en: `The following keywords are clustered from news headlines and are not related to the main content of the news articles.`,
  zh: '关键词仅通过新闻标题归类',
};

export const newsTitleText: TipsMapType = {
  en: (
    <>
      The sentiment score, channel, country, and language data of the news page
      have been updated since 2022-09-02. The keyword and topic data have been
      updated since 2023-05-30.
    </>
  ),
  zh: (
    <>
      新闻页的情感分、渠道、国家/地区、语种数据从2022-09-02开始更新。关键词和话题数据从2023-05-30开始更新。
    </>
  ),
};

export const newsMapTips: TipsMapType = {
  en: (
    <>
      The label 'Unidentified' represents news that cannot distinguish
      region/country.
    </>
  ),
  zh: <>无法区分地区/国家的新闻。</>,
};

export const newsEngagementTips: TipsMapType = {
  en: (
    <>
      The sum of the likes and comments (if available) of a news article. This
      metric is only applicable to news data sourced from "DataBrain".
    </>
  ),
  zh: (
    <>
      新闻文章的点赞与评论（如有）的总和。此指标仅适用于来源于“DataBrain”的新闻数据。
    </>
  ),
};

export const newsUVPMTips: TipsMapType = {
  en: (
    <>
      This KPI is not meant to be precise by any mean and is an extremely rough
      estimation, based on various elements (audience, followers, views, etc)
      depending on the publication type (articles, posts, videos, etc).
    </>
  ),
  zh: (
    <>
      此KPI指标并不旨在精确衡量，而是基于不同因素（如受众、关注者、浏览量等）和发布内容类型（如文章、帖子、视频等）的粗略估算
    </>
  ),
};

export const newsTotalArticlesTips: TipsMapType = {
  en: <>Total news articles mentioning the game</>,
  zh: <>提及游戏的新闻文章总篇数</>,
};

export const newsHotTabTips: TipsMapType = {
  en: (
    <>
      Sort by engagement; for news items with no engagement yet, apply random
      ordering.
    </>
  ),
  zh: <>按互动量排序，针对目前没有互动量的新闻，将随机排序。</>,
};

